var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.09961 6.65495C3.09961 4.69152 4.69128 3.09985 6.6547 3.09985C8.61812 3.09985 10.2098 4.69152 10.2098 6.65495C10.2098 8.61837 8.61812 10.21 6.6547 10.21C4.69128 10.21 3.09961 8.61837 3.09961 6.65495ZM6.6547 2.09985C4.13899 2.09985 2.09961 4.13924 2.09961 6.65495C2.09961 9.17065 4.13899 11.21 6.6547 11.21C7.73249 11.21 8.72285 10.8357 9.50287 10.21L12.6462 13.3533C12.8415 13.5486 13.158 13.5486 13.3533 13.3533C13.5486 13.158 13.5486 12.8415 13.3533 12.6462L10.21 9.50285C10.8356 8.72287 11.2098 7.73261 11.2098 6.65495C11.2098 4.13924 9.17041 2.09985 6.6547 2.09985Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.bdf0cade674a63b0ae89cecb11d85ec9.svg";
export { ForwardRef as ReactComponent };